import type {CompetitorPlayersStatsModuleState} from "../../models/competitor-players-stats-module.state";
import {COMPETITOR_PLAYER_STATS} from "../../competitor-players-stats-module.consts";
import {AnalyticsEventHandler} from "../../../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../../../third-party-services/analytics/analytics-service";
import {CompetitorPlayerStatsModuleTabClickEventModel} from "../../models/analytics/competitor-player-stats.module.tab-click.event.model";

export class CompetitorPlayerStatsModuleTabClickEventHandler extends AnalyticsEventHandler {
  state: CompetitorPlayersStatsModuleState;
  type: String = COMPETITOR_PLAYER_STATS.ACTION_TYPES.tabClick;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = CompetitorPlayerStatsModuleTabClickEventModel;
  }
}